import {
  getListNation,
  getListNationality,
  getListTravellerLevel
} from '@/api/common/code_base'
import { getMarketSegmentApi } from '@/api/common/marketSegment'
import { getSourceListApi } from '@/api/common/source'
import { getUserApi } from '@/api/userConfig/user'
import { Message } from 'element-ui'

// export async function getAllProfileType() {
// }

export async function getAllNation() {
  let res = null
  try {
    res = await getListNation()
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi!',
      type: 'error'
    })
  } finally {
    //
  }
  return res?.data || []
}

export async function getAllNationality() {
  let res = null
  try {
    res = await getListNationality()
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi!',
      type: 'error'
    })
  } finally {
    //
  }
  return res?.data || []
}

export async function getAllBusinessMan() {
  let res = null
  try {
    res = await getUserApi({ department: 'SALE' })
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi!',
      type: 'error'
    })
  } finally {
    //
  }
  return (
    res?.data.map(item => ({
      ...item,
      id: item.account.id,
      username: item.account.username,
      full_name: item.account.full_name
    })) || []
  )
}

export async function getAllMarketSeg() {
  let res = null
  try {
    res = await getMarketSegmentApi({ isActive: 1 })
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi!',
      type: 'error'
    })
  } finally {
    //
  }
  return (res?.data || []).map(item => ({
    ...item,
    id: item.id,
    code: item.code,
    desc: item.desc
  }))
}

export async function getAllSource() {
  let res = null
  try {
    res = await getSourceListApi({ isActive: 1 })
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi!',
      type: 'error'
    })
  } finally {
    //
  }
  return (res?.data || []).map(item => ({
    ...item,
    id: item.id,
    code: item.code,
    desc: item.desc
  }))
}

export async function getAllTravellerLevel() {
  let res = null
  try {
    res = await getListTravellerLevel()
    if (res.is_error) {
      throw new Error(res)
    }
  } catch (error) {
    console.log(error)
    Message({
      message: 'Lỗi!',
      type: 'error'
    })
  } finally {
    //
  }
  return (res?.data || []).map(item => ({
    ...item,
    id: item.id,
    code: item.code,
    desc: item.desc
  }))
}
